// Per-route SEO metadata for the hash-based router in App.jsx.
// Each entry drives <title>, meta description, canonical URL and Open Graph
// tags via the useSEO hook (see useSEO.js). Keys must match the route hashes
// used in App.jsx's `routes` object.

const SITE = 'https://aerialroot.in';
const DEFAULT_IMAGE = `${SITE}/og-image.jpg`;

const seoData = {
  '': {
    title: 'Aerialroot Infotech | Digital Marketing & Web Development Agency – Trichy, Tamil Nadu',
    description: 'Aerialroot Infotech is a results-driven digital marketing and web development agency based in Trichy (Tiruchirappalli), Tamil Nadu. SEO, Meta Ads, Google Ads, social media, branding and custom websites.',
    path: '/',
  },
  '#/about': {
    title: 'About Us | Aerialroot Infotech – Digital Marketing Agency in Trichy',
    description: 'Learn about Aerialroot Infotech — our mission, team and approach to helping Tamil Nadu businesses grow through digital marketing, branding and web development.',
    path: '/#/about',
  },
  '#/services': {
    title: 'Our Services | SEO, Meta Ads, Web Development & Branding – Aerialroot Infotech',
    description: 'Explore Aerialroot Infotech\'s digital marketing and web development services: SEO, Google & Meta Ads, social media management, branding, logo design and custom websites in Trichy, Tamil Nadu.',
    path: '/#/services',
  },
  '#/services/website-development': {
    title: 'Website Development Services in Trichy | Aerialroot Infotech',
    description: 'Custom, responsive website design and development for businesses in Trichy and across Tamil Nadu — fast, SEO-friendly websites built by Aerialroot Infotech.',
    path: '/#/services/website-development',
  },
  '#/services/digital-marketing': {
    title: 'Digital Marketing Services in Trichy | Aerialroot Infotech',
    description: 'Grow your business with Aerialroot Infotech\'s digital marketing services — SEO, Google Ads, Meta Ads and social media management for brands in Tamil Nadu.',
    path: '/#/services/digital-marketing',
  },
  '#/services/graphic-design': {
    title: 'Graphic Design & Branding Services in Trichy | Aerialroot Infotech',
    description: 'Logo design, branding and graphic design services from Aerialroot Infotech, helping Tamil Nadu businesses build a distinctive visual identity.',
    path: '/#/services/graphic-design',
  },
  '#/services/ai-solutions': {
    title: 'AI Solutions for Business | Aerialroot Infotech, Trichy',
    description: 'AI-powered marketing and automation solutions from Aerialroot Infotech to help businesses in Trichy and Tamil Nadu work smarter and grow faster.',
    path: '/#/services/ai-solutions',
  },
  '#/services/custom-software-development': {
    title: 'Custom Software Development Services in Trichy | Aerialroot Infotech',
    description: 'Bespoke web applications, internal tools, dashboards, and business software built around your exact workflow — custom software development by Aerialroot Infotech, Trichy.',
    path: '/#/services/custom-software-development',
  },
  '#/portfolio': {
    title: 'Our Work & Case Studies | Aerialroot Infotech Portfolio',
    description: 'See real results from Aerialroot Infotech\'s digital marketing and web development projects — a portfolio of websites, campaigns and case studies from Trichy, Tamil Nadu.',
    path: '/#/portfolio',
  },
  '#/videos': {
    title: 'Videos | Aerialroot Infotech',
    description: 'Watch the latest videos from Aerialroot Infotech covering digital marketing tips, client work and behind-the-scenes from our Trichy studio.',
    path: '/#/videos',
  },
  '#/blog': {
    title: 'Blog | Digital Marketing & Web Development Insights – Aerialroot Infotech',
    description: 'Tips, guides and insights on SEO, digital marketing, branding and web development from the Aerialroot Infotech team in Trichy, Tamil Nadu.',
    path: '/#/blog',
  },
  '#/contact': {
    title: 'Contact Us | Aerialroot Infotech – Trichy, Tamil Nadu',
    description: 'Get in touch with Aerialroot Infotech for digital marketing and web development services in Trichy, Tamil Nadu. Call, email or visit us at D-11, Thilai Nagar.',
    path: '/#/contact',
  },
};

// Aliases that should show the same metadata as another route
seoData['#/'] = seoData[''];
seoData['#/home'] = seoData[''];

export function getSEO(route) {
  const entry = seoData[route]
    || (route && route.startsWith('#/blog/') ? seoData['#/blog'] : null)
    || seoData[''];
  return {
    ...entry,
    url: `${SITE}${entry.path}`,
    image: entry.image || DEFAULT_IMAGE,
  };
}

export default seoData;
